import { Brand, BurgerIcon, Logo, MenuButton } from './LogoMenu.style';
import { Link } from 'react-router-dom';
import React from 'react';
import classNames from 'classnames';

/**
 * A list of field rows with a header.
 *
 * @param {Object} props All the properties passed to the React Component.
 * @returns {Element} Stateless functional React component.
 */
const LogoMenu = ({
  toggleMenu = () => {},
  isOpen = true,
  isLoggedIn = false,
  smallScreen = true,
  homeLink = '/',
  logo
}) =>
  isLoggedIn && smallScreen ? (
    <MenuButton onClick={() => toggleMenu(!isOpen)}>
      <BurgerIcon className={classNames({ close: isOpen })} />
    </MenuButton>
  ) : (
    <Brand tag={Link} to={homeLink}>
      <Logo logo={logo} />
    </Brand>
  );

export default LogoMenu;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/LogoMenu/LogoMenuComponent.js